import Vue from 'vue'

export default {
  codigo_usuario: null,
  usuario: {},
  pagina: 1,
  campo_busqueda: '',
  criterio_busqueda: '',
  registros_por_pagina: 20,
  token_verificacion: '',
  contentType: '',
  recuperar_clave: {
    correo_electronico: ''
  },
  asignar_clave: {
    correo_electronico: '',
    clave: '',
    confirmacion_clave: '',
    token_verificacion: ''
  },
  getProfile () {
    let token = JSON.parse(sessionStorage.getItem('token'))
    return new Promise((resolve, reject) => {
      Vue.http.get(
        'api/user/profile',
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': token.token_type + ' ' + token.access_token
          }
        }
      ).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      })
    })
  },
  getListadoUsuarios () {
    let token = JSON.parse(sessionStorage.getItem('token'))

    return new Promise((resolve, reject) => {
      Vue.http.get(
        'api/users?page=' + this.pagina + '&per_page=' + this.registros_por_pagina + '&' + this.campo_busqueda + '=' + this.criterio_busqueda,
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': token.token_type + ' ' + token.access_token
          }
        }
      ).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      })
    })
  },
  getUsuario () {
    let token = JSON.parse(sessionStorage.getItem('token'))
    return new Promise((resolve, reject) => {
      Vue.http.get(
        'api/users/' + this.codigo_usuario,
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': token.token_type + ' ' + token.access_token
          }
        }
      ).then((response) => {
        // console.log(response.data)
        resolve(response.data)
      }, response => {
        resolve(response.data)
      })
    })
  },
  getUsuarioAutenticado () {
    let token = JSON.parse(sessionStorage.getItem('token'))
    return new Promise((resolve, reject) => {
      Vue.http.get(
        'api/oauth/user/authenticated',
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': token.token_type + ' ' + token.access_token
          }
        }
      ).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      })
    })
  },
  registerUsuario () {
    return new Promise((resolve, reject) => {
      Vue.http.post(
        'api/users/register',
        this.usuario,
        {
          headers: {
            'Content-Type': this.contentType,
            'Accept': 'application/json'
          }
        }
      ).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      })
    })
  },
  recuperarClave () {
    return new Promise((resolve, reject) => {
      Vue.http.post(
        'api/users/recover/password',
        this.recuperar_clave,
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      ).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      })
    })
  },
  asignarClave () {
    return new Promise((resolve, reject) => {
      Vue.http.post(
        'api/users/assign/password',
        this.asignar_clave,
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      ).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      })
    })
  },
  verificarCuenta () {
    return new Promise((resolve, reject) => {
      Vue.http.get(
        'api/users/verify/' + this.token_verificacion,
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      ).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      })
    })
  },
  postUsuario () {
    let token = JSON.parse(sessionStorage.getItem('token'))
    return new Promise((resolve, reject) => {
      Vue.http.post(
        'api/users',
        this.usuario,
        {
          headers: {
            'Content-Type': this.contentType,
            'Accept': 'application/json',
            'Authorization': token.token_type + ' ' + token.access_token
          }
        }
      ).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      })
    })
  },
  putUsuario () {
    let token = JSON.parse(sessionStorage.getItem('token'))
    return new Promise((resolve, reject) => {
      Vue.http.put(
        'api/users/' + this.codigo_usuario,
        this.usuario,
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': token.token_type + ' ' + token.access_token
          }
        }
      ).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      })
    })
  },
  deleteUsuario () {
    let token = JSON.parse(sessionStorage.getItem('token'))
    return new Promise((resolve, reject) => {
      Vue.http.delete(
        'api/users/' + this.codigo_usuario,
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': token.token_type + ' ' + token.access_token
          }
        }
      ).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/js/usuario.js